import { render, staticRenderFns } from "./ServiceInfoInteriorDesign.vue?vue&type=template&id=2f1bca1a&scoped=true&"
import script from "./ServiceInfoInteriorDesign.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoInteriorDesign.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoInteriorDesign.vue?vue&type=style&index=0&id=2f1bca1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bca1a",
  null
  
)

export default component.exports